/**
 * Opens a print-friendly browser window with the data table, then triggers the print dialog.
 * No external libraries needed — works in all modern browsers.
 *
 * @param {string} title        - Report title (e.g. "Clients")
 * @param {string} subtitle     - Sub-label (e.g. "Active clients as of 2026-04-13")
 * @param {Array}  columns      - [{label: "Client Name", key: "legal_name"}, ...]
 * @param {Array}  rows         - Array of data objects
 */
export function exportListPDF(title, subtitle, columns, rows) {
  const fmtVal = (v) => {
    if (v === null || v === undefined) return '—';
    if (typeof v === 'boolean') return v ? 'Yes' : 'No';
    return String(v);
  };

  const tableRows = rows.map(row =>
    `<tr>${columns.map(c => `<td>${fmtVal(row[c.key])}</td>`).join('')}</tr>`
  ).join('');

  const html = `<!DOCTYPE html>
<html>
<head>
  <meta charset="UTF-8" />
  <title>${title} — Eyvo Finance Ops</title>
  <style>
    * { box-sizing: border-box; margin: 0; padding: 0; }
    body { font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif; padding: 36px 40px; color: #1e293b; font-size: 11px; }
    .header { display: flex; justify-content: space-between; align-items: flex-end; margin-bottom: 20px; border-bottom: 2px solid #1e293b; padding-bottom: 12px; }
    .header h1 { font-size: 20px; font-weight: 700; color: #1e293b; }
    .header p  { font-size: 10px; color: #64748b; margin-top: 3px; }
    .header .logo { font-size: 13px; font-weight: 700; color: #312e81; letter-spacing: -0.5px; }
    table { width: 100%; border-collapse: collapse; margin-top: 4px; }
    thead th { background: #1e293b; color: #f8fafc; text-align: left; padding: 7px 9px; font-size: 9px; font-weight: 600; text-transform: uppercase; letter-spacing: 0.06em; }
    tbody td { padding: 6px 9px; border-bottom: 1px solid #e2e8f0; color: #334155; vertical-align: top; }
    tbody tr:nth-child(even) td { background: #f8fafc; }
    .footer { margin-top: 16px; font-size: 9px; color: #94a3b8; display: flex; justify-content: space-between; }
    @media print {
      body { padding: 0; }
      .no-print { display: none; }
    }
  </style>
</head>
<body>
  <div class="header">
    <div>
      <h1>${title}</h1>
      <p>${subtitle}</p>
    </div>
    <div class="logo">Eyvo Finance Ops</div>
  </div>
  <table>
    <thead>
      <tr>${columns.map(c => `<th>${c.label}</th>`).join('')}</tr>
    </thead>
    <tbody>${tableRows}</tbody>
  </table>
  <div class="footer">
    <span>${rows.length} record${rows.length !== 1 ? 's' : ''}</span>
    <span>Generated ${new Date().toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' })} ${new Date().toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' })}</span>
  </div>
</body>
</html>`;

  const win = window.open('', '_blank', 'width=900,height=700');
  if (!win) { alert('Please allow pop-ups to export PDF'); return; }
  win.document.write(html);
  win.document.close();
  win.focus();
  setTimeout(() => { win.print(); }, 600);
}
